import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Button, Form, Modal, Select, Typography } from "antd";
import Parse from "parse";
import React, { useEffect, useState } from "react";
import {
  Kanban_State,
  Ticket_Kanban_State,
} from "../../../../js/parsegenerated";

export const KanbanStateDeleteModal = (props: {
  monitorstate: Kanban_State;
  onOk: Function;
  onCancel: Function;
  open: boolean;
}) => {
  const t = useTranslation();
  const [loading, setLoading] = useState(false);
  const [monitorStates, setKanbanStates] = useState<Kanban_State[]>();
  const [otherInboxes, setOtherInboxes] = useState<Kanban_State[]>();
  const [otherOutboxes, setOtherOutboxes] = useState<Kanban_State[]>();
  const [destinationColumn, setDestinationColumn] = useState<Kanban_State>();
  const [form] = Form.useForm();
  const { Option } = Select;
  const { Title, Text } = Typography;

  const handleChange = async (value: string) => {
    await new Parse.Query(Kanban_State)
      .get(value)
      .then((destinationcolumn: Kanban_State) => {
        setDestinationColumn(destinationcolumn);
      });
  };

  const deleteKanbanState = () => {
    form
      .validateFields()
      .then((formvalues) => {
        new Parse.Query(Ticket_Kanban_State)
          .equalTo("state", props.monitorstate)
          .find()
          .then(async (values: Ticket_Kanban_State[]) => {
            if (!destinationColumn) return;

            // Set the new column for every object
            values.map(async (value) => {
              value.set("state", destinationColumn);
              await value.save();
            });

            // Set values for destinationcolumn
            if (isColumnInbox()) {
              destinationColumn.set("isInbox", true);
            }
            if (isColumnOutbox()) {
              destinationColumn.set("isFinished", true);
            }
            await destinationColumn.save();

            // Delete the column
            const destroyedcolumn = await props.monitorstate.save({
              enabled: false,
            });
            props.onOk();
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const isColumnInbox = () => {
    if (!otherInboxes) {
      return;
    }

    if (props.monitorstate.get("isInbox") && otherInboxes.length === 0) {
      return true;
    }
    return false;
  };

  const isColumnOutbox = () => {
    if (!otherOutboxes) {
      return;
    }

    if (props.monitorstate.get("isFinished") && otherOutboxes.length === 0) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    new Parse.Query(Kanban_State)
      .equalTo("enabled", true)
      .notEqualTo("objectId", props.monitorstate.id)
      .find()
      .then((monitorstates) => {
        setKanbanStates(monitorstates);
      });

    new Parse.Query(Kanban_State)
      .equalTo("isInbox", true)
      .equalTo("enabled", true)
      .notEqualTo("objectId", props.monitorstate.id)
      .find()
      .then((otherinboxes: Kanban_State[]) => {
        setOtherInboxes(otherinboxes);
      });

    new Parse.Query(Kanban_State)
      .equalTo("isFinished", true)
      .equalTo("enabled", true)
      .notEqualTo("objectId", props.monitorstate.id)
      .find()
      .then((otheroutboxes: Kanban_State[]) => {
        setOtherOutboxes(otheroutboxes);
      });
  }, []);

  return (
    <Modal
      title={t("maintenance:monitor.manage.delete.confirm.title")}
      open={props.open}
      onOk={deleteKanbanState}
      onCancel={() => {
        props.onCancel();
      }}
      width={"80%"}
      getContainer={false}
      footer={[
        <Button
          key="back"
          onClick={() => {
            props.onCancel();
          }}
        >
          {t("maintenance:global.button.cancel_label")}
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={deleteKanbanState}
          danger
        >
          {t("maintenance:global.button.delete_label")}
        </Button>,
      ]}
    >
      <Title level={5}>
        {t("maintenance:monitor.manage.delete.confirm.content.1")}
      </Title>
      {isColumnInbox() && (
        <>
          <Text type="warning">
            <Icon icon="fa:exclamation"></Icon>
            {t("maintenance:monitor.manage.delete.confirm.content.isInbox")}
          </Text>
        </>
      )}

      {isColumnOutbox() && (
        <>
          <Text type="warning">
            <Icon icon="fa:exclamation"></Icon>
            {t("maintenance:monitor.manage.delete.confirm.content.isOutbox")}
          </Text>
        </>
      )}

      <Form form={form}>
        <Form.Item
          name="destination"
          rules={[
            {
              required: true,
              message: t(
                "maintenance:monitor.manage.delete.confirm.form.destination.rules.required"
              ),
            },
          ]}
        >
          <Select
            style={{ width: "100%", marginTop: 30 }}
            onChange={handleChange}
          >
            {monitorStates?.map((monitorstate) => {
              return (
                <Option key={monitorstate.id} value={monitorstate.id}>
                  {monitorstate.get("label")}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};
